import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import EnrollmentFooter, { EnrollmentFooterPlaceholder } from './EnrollmentFooter';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentFooterContainer = () => /*#__PURE__*/_jsx(IntersectionObserver, {
  onIntersectionChange: ({
    entries,
    observer
  }) => {
    if (entries[0].isIntersecting) {
      observer.disconnect();
    }
  },
  renderContent: isIntersecting => {
    if (isIntersecting) {
      return /*#__PURE__*/_jsx(EnrollmentFooter, {});
    }
    return /*#__PURE__*/_jsx(EnrollmentFooterPlaceholder, {});
  }
});
export default EnrollmentFooterContainer;